import type { Bot } from '@/api/schema'
import { BirthRequired } from '@/app/components/BirthRequired/BirthRequired'
import { MatrixSections } from '@/app/pages/ChatPage/MenuSections/MatrixSections'
import { NatalSections } from '@/app/pages/ChatPage/MenuSections/NatalSections'
import { TarotSections } from '@/app/pages/ChatPage/MenuSections/TarotSections'
import { useChat } from '@/app/state/chat'
import { useChatMenu } from '@/app/state/chatMenu'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import styles from './index.module.scss'

export const ChatMenu: FunctionalComponent<{
  bot: Bot
}> = props => {
  const chatSubmit = useChat(s => s.submit)
  const hideChatMenu = useChatMenu(s => s.hide)
  const chatMenuVisible = useChatMenu(s => s.visible)
  const groupId = useChatMenu(s => s.groupId)

  const [birthRequiredVisible, setBirthRequiredVisible] = useState(false)
  const [activeGroupId, setActiveGroupId] = useState<string | undefined>()
  const initialGroupId = groupId ?? activeGroupId

  useEffect(() => {
    hideChatMenu()
  }, [])

  return (
    <div
      class={classNames(styles.root, {
        [styles.active]: chatMenuVisible,
      })}
    >
      {chatMenuVisible && (
        props.bot === 'milana'
          ? (
            <MatrixSections
              onClose={hideChatMenu}
              initialGroupId={initialGroupId}
              onGroupChange={setActiveGroupId}
              onSectionClick={(group, question) => {
                hideChatMenu()
                chatSubmit(question, {
                  groupId: group.id,
                })
              }}
            />
          )
          : props.bot === 'zoe'
          ? (
            <NatalSections
              initialGroupId={initialGroupId}
              onGroupChange={setActiveGroupId}
              onClose={hideChatMenu}
              onLockedSectionClick={() => {
                setBirthRequiredVisible(true)
              }}
              onAspectClick={(groupId, question) => {
                hideChatMenu()
                chatSubmit(question, {
                  groupId: groupId,
                })
              }}
              onSectionClick={(section, group) => {
                hideChatMenu()
                chatSubmit(section.question, {
                  groupId: group.id,
                })
              }}
            />
          )
          : (
            <TarotSections
              initialGroupId={initialGroupId}
              onGroupChange={setActiveGroupId}
              onClose={hideChatMenu}
              onQuestionClick={(topic, question) => {
                hideChatMenu()
                chatSubmit(question, {
                  groupId: topic.id,
                })
              }}
            />
          )
      )}

      {birthRequiredVisible && (
        <BirthRequired
          onClose={() => {
            setBirthRequiredVisible(false)
          }}
        />
      )}
    </div>
  )
}
